import { FontWeight } from '@hhgtech/hhg-components/mantine'
import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      [theme.fn.smallerThan('sm')]: {
        '.mantine-Carousel-viewport': {
          paddingLeft: 16,
          paddingRight: 16,
        },
        '.carousel-progress': {
          marginLeft: 16,
          marginRight: 16,
        },
      },
    },
    accordionItem: {
      border: 0,
    },
    accordionLabel: {
      padding: 0,
    },
    accordionControl: {
      padding: `${rem(12)} ${rem(18)}`,
      borderTop: 0,
      borderBottom: `1px solid ${theme.colors.neutral[1]}`,
      '.mantine-Accordion-label p': {
        fontWeight: FontWeight.regular,
      },
      '&[data-active="true"]': {
        borderBottom: 0,
        '.mantine-Accordion-label p': {
          fontWeight: FontWeight.semiBold,
        },
      },
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    accordionContent: {
      paddingBottom: 0,
      [theme.fn.smallerThan('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
        marginLeft: -16,
        marginRight: -16,
      },
    },
  }
})
